import { handleActions } from 'redux-actions';
import { mergeIn } from 'utils/helpers/ramdaStateHelpers';
import types from './types';

const reducers = handleActions({
  [types.SET_PENDING_STATUS]: mergeIn((action) => action.payload),
}, null);

export default reducers;
